import React from 'react';
import classnames from 'classnames/bind';

import Pagination from '../Pagination';
import NumeralPageView from './NumeralPageView';
import Icon from 'foundations/Icons/Icon';
import styles from './NumeralPagination.css';

const cx = classnames.bind(styles);

const breakView = key => <li key={key}><span>...</span></li>;

export default class NumeralPagination extends Pagination {
  maxItems = 10;
  totalDisplayItems= this.totalPages;

  buildHref = pageIndex => {
    const { hrefBuilder } = this.props;

    return hrefBuilder ? hrefBuilder(pageIndex) : '/#';
  }

  /* eslint-disable react/display-name */
  getPageView = index => {
    const { currentPage } = this.state;

    return (
      <NumeralPageView
        key={index}
        onClick={this.selectPage.bind(null, index)}
        isCurrentPage={currentPage === index}
        href={this.buildHref(index)}
        page={index}
      />
    );
  }

  getMin = totalPages => {
    const { currentPage } = this.state;

    const startTruncation = currentPage - (currentPage < 6 ? 3 : 2);
    // we need to adjust the truncation offset if is the initial range of numbers (only with one ellipsis)

    const endTruncation = totalPages - this.maxItems + 3;
    const min = totalPages - currentPage <= 4 ? endTruncation : startTruncation;

    return Math.max(min, 2);
  }

  getMax = totalPages => {
    const { currentPage } = this.state;

    const isEndNumberRange = currentPage > totalPages - this.maxItems + 4;

    const startTruncation = this.maxItems - 2;
    const endTruncation = isEndNumberRange ? currentPage + 4 : currentPage + 3;
    // we need to adjust the truncation offset if is the final range of numbers (only with one ellipsis)

    const max = currentPage <= 4 ? startTruncation : endTruncation;

    return Math.min(max, totalPages - 1);
  }

  renderPaginationNumbers = () => {
    const links = [];
    const totalPages = this.totalPages;

    let min = 2;
    let max = totalPages - 1;

    // first page
    links.push(this.getPageView(1));

    if (totalPages > this.maxItems) {
      // this specifies the range of pages we want to show in the middle
      min = this.getMin(totalPages);
      max = this.getMax(totalPages);
    }

    // first ellipsis
    if (min > 2) { links.push(breakView(2)); }

    for (let i = min; i <= max; ++i) {
      links.push(this.getPageView(i));
    }

    // last ellipsis
    if (max < totalPages - 1) { links.push(breakView(max + 1)); }

    //last page
    links.push(this.getPageView(totalPages));

    return links;
  };

  render() {
    const { currentPage } = this.state;
    const pagesTotal = this.totalPages;

    if (pagesTotal <= 1) { return null; }

    const previowsArrowClass = cx('navigationArrow', { 'disabled': currentPage === 1 });
    const nextArrowClass     = cx('navigationArrow', { 'disabled': currentPage === pagesTotal});

    return (
      <ul
        className={cx('paginationList')}
        role="navigation"
        aria-label="Pagination"
        onKeyDown={this.onKeyPressed}
      >
        <li className={previowsArrowClass}>
          <a onClick={this.handlePreviousPage}
            href={this.buildHref(currentPage - 1)}
            role='button'
            onKeyPress={this.handlePreviousPage}
            rel="prev"
            title="Previous page"
            aria-label="Previous page">
            <Icon icon="page-previous" type="20" />
          </a>
        </li>

        {this.renderPaginationNumbers()}

        <li className={nextArrowClass}>
          <a onClick={this.handleNextPage}
            href={this.buildHref(currentPage + 1)}
            role='button'
            onKeyPress={this.handleNextPage}
            rel="next"
            title="Next page"
            aria-label="Next page">
            <Icon icon="page-next" type="20" />
          </a>
        </li>
      </ul>
    );
  }
}

NumeralPagination.displayName = 'NumeralPagination';



// WEBPACK FOOTER //
// ./src/uis/elements/Pagination/NumeralPagination/NumeralPagination.js